import { FC, useEffect } from "react";
import Success from "../../../../assets/icon/Success";
import { useAppDispatch } from "../../../../hooks/redux-hooks";
import { setSuccessMessageByVoteModal } from "../../../../store/slices/main";

const SuccessMessageByVoteModal: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSuccessMessageByVoteModal(false));
    }, 3000);

    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <div className="w-full px-8">
      <div className="w-full flex flex-col items-center justify-center max-w-[30rem] h-auto text-center">
        <Success />
        <h2 className="py-8 text-xl font-bold" id="modal-title">
          Дякуємо, голос зараховано
        </h2>
      </div>
    </div>
  );
};

export default SuccessMessageByVoteModal;
